import React, { FC } from 'react';
import styles from './ProfileMenu.module.scss'; 
import { useTranslation } from 'react-i18next';
import ArrowSvgLang from '../UI/ArrowSvgLang';

type Props = {
  onClose: () => void;
  text: string;
};
const ProfileMenuHeader: FC<Props> = ({ onClose, text }) => {
   const {t } = useTranslation() as any
  return (
    <div className={styles.menu__profile_header}>
      <ArrowSvgLang onClick={onClose} />
      <div className={styles.menu__profile_title}>{t(text)}</div>
    </div>
  );
};

export default ProfileMenuHeader;
